import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col, Form, Button } from "react-bootstrap";
import { Formik } from "formik";

// Components
import Icon from "../Icon";
import color from "../../assets/color";

// Helper
import Helper from "../../helpers/Helper";
import { country_code } from "../../helpers/Constant";
import yup from "../../helpers/Validation";

let fields = {
  country_code: "+60",
  phone_no: "",
  password: "",
};

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showPassword: false,
    };
  }

  _togglePassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  _onLogin = (params) => {
    let phoneNo = params.phone_no;
    if (phoneNo.charAt(0) === "0") {
      params.phone_no = phoneNo.substring(1);
    }

    params.language = "en";

    this.props.onSubmit(params);
  };

  render() {
    const { showPassword } = this.state;

    const schema = yup.object({
      country_code: yup.string().required("Please select country code."),
      phone_no: yup
        .string()
        .required("Please enter phone no.")
        .min(8)
        .max(10)
        .test("phone", "Please enter valid phone no", (value) => {
          if (value.charAt(0) === "0") {
            value = value.substring(1);
          }
          const form = this.form;
          const values = form.state.values;

          return Helper.validatePhoneWithCountryCode(
            value,
            values.country_code
          );
        }),
      password: yup.string().required(),
    });

    return (
      <Row noGutters={true}>
        <Col xs={12} lg={6}>
          <div className="inner-container grey d-flex flex-column justify-content-between align-items-center">
            <div className="d-lg-none d-xl-none position-relative align-self-end">
              <div className="btn-close" onClick={this.props.onHide}>
                <Icon
                  type="custom"
                  name="closecircle"
                  color={color.black}
                  size={30}
                />
              </div>
            </div>
            <div className="title flex-grow-1 d-flex flex-column justify-content-center align-items-center text-center">
              <Icon
                type="custom"
                name="login"
                color={color.black}
                className="icon-login"
              />
              <h1>LOGIN</h1>
            </div>

            <p className="mb-0 d-none d-lg-block d-xl-block">
              Don't have an account.{" "}
              <span
                className="clickable font-weight-bold"
                onClick={this.props.goToSignUp}
              >
                Sign Up
              </span>
            </p>
          </div>
        </Col>
        <Col xs={12} lg={6}>
          <div className="inner-container d-flex flex-column">
            <div className="d-none d-lg-block d-xl-block position-relative text-right">
              <div className="btn-close" onClick={this.props.onHide}>
                <Icon
                  type="custom"
                  name="closecircle"
                  color={color.black}
                  size={30}
                />
              </div>
            </div>
            <Formik
              ref={(el) => (this.form = el)}
              validationSchema={schema}
              onSubmit={this._onLogin}
              initialValues={fields}
              validateOnBlur={true}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                isValid,
                touched,
                errors,
              }) => {
                return (
                  <Form
                    noValidate
                    className="h-100 d-flex flex-column flex-grow-1 justify-content-between"
                    onSubmit={handleSubmit}
                  >
                    <div className="flex-grow-1">
                      <h5>Fill in your phone no. and password.</h5>
                      <Form.Group>
                        <Form.Row>
                          <Col xs={5} md={4} controlid="validationCountryCode">
                            <Form.Label>Country Code</Form.Label>
                            <Form.Control
                              placeholder="First name"
                              as="select"
                              name="country_code"
                              value={values.country_code}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                !!touched.country_code && !!errors.country_code
                              }
                            >
                              {country_code.map((data) => (
                                <option
                                  key={data.dial_code}
                                  value={data.dial_code}
                                >
                                  {data.dial_code}
                                </option>
                              ))}
                            </Form.Control>
                          </Col>
                          <Col xs={7} md={8} controlid="validationPhoneNo">
                            <Form.Label>Phone No.</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Phone No."
                              name="phone_no"
                              value={values.phone_no}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                !!touched.phone_no && !!errors.phone_no
                              }
                              maxLength={11}
                            />
                            {touched.phone_no && errors.phone_no && (
                              <Form.Control.Feedback type="invalid">
                                {errors.phone_no}
                              </Form.Control.Feedback>
                            )}
                          </Col>
                        </Form.Row>
                      </Form.Group>
                      <Form.Group
                        className="position-relative"
                        controlid="validationPassword"
                      >
                        <Form.Label>Password</Form.Label>

                        <Form.Control
                          type={showPassword ? "text" : "password"}
                          placeholder="Password"
                          name="password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={!!touched.password && !!errors.password}
                        />
                        {touched.password && errors.password && (
                          <Form.Control.Feedback type="invalid">
                            {errors.password}
                          </Form.Control.Feedback>
                        )}
                        {isValid && (
                          <div
                            className="btn-toggle-password"
                            onClick={this._togglePassword}
                          >
                            <Icon
                              type="custom"
                              name={showPassword ? "view" : "hide"}
                              color={color.primary}
                              size={20}
                            />
                          </div>
                        )}
                      </Form.Group>
                      <div
                        className="clickable"
                        onClick={this.props.goToForgotPassword}
                      >
                        Forgot Password
                      </div>
                    </div>
                    <Button
                      className="mt-4"
                      type="submit"
                      disabled={!isValid}
                      variant="primary"
                      block
                    >
                      LOGIN
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </Col>
        <Col xs={12} lg={6} className="d-lg-none d-xl-none">
          <div className="inner-container grey">
            <p className="text-center mb-0">
              Don't have an account.{" "}
              <span
                className="clickable font-weight-bold"
                onClick={this.props.goToSignUp}
              >
                Sign Up
              </span>
            </p>
          </div>
        </Col>
      </Row>
    );
  }
}

Login.propTypes = {
  onHide: PropTypes.func.isRequired,
  // Function
  goToSignUp: PropTypes.func.isRequired,
  goToForgotPassword: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default Login;
